// src/config.js
const getBackendUrl = () => {
    const configuredUrl = process.env.REACT_APP_BACKEND_URL;
    if (configuredUrl) {
        return configuredUrl;
    }

    if (typeof window === 'undefined') {
        return 'not found';
    }

    const hostname = window.location.hostname;
    const protocol = window.location.protocol || 'https:';

    if (hostname.includes('.app.github.dev')) {
        const codespaceBackendHost = hostname.replace(/-\d+\.app\.github\.dev$/, '-8000.app.github.dev');
        return `${protocol}//${codespaceBackendHost}`;
    }

    if (hostname === 'localhost') {
        return 'http://localhost:8000';
    }

    return 'not found';
};

const getFrontendUrl = () => {
    if (typeof window === 'undefined') {
        return process.env.REACT_APP_FRONTEND_URL || 'not found';
    }

    return `${window.location.protocol}//${window.location.host}`;
};

const env = {
    backendUrl: getBackendUrl(),
    frontendUrl: process.env.REACT_APP_FRONTEND_URL || getFrontendUrl(),
    teste: process.env.REACT_APP_API_KEY || 'not found',
};

export default env;